import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PosthogService } from './posthog.service';
import { GlobalService } from './global.service';

@Injectable({ providedIn: 'root' })
export class SessionRecordingService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly router = inject(Router);
  private readonly posthogService = inject(PosthogService);
  private readonly globalService = inject(GlobalService);

  private recordingStarted = false;

  init(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.router.events
      .pipe(
        filter((e): e is ActivationEnd => e instanceof ActivationEnd),
        filter((e) => !this.recordingStarted && !!e.snapshot?.data?.['sessionRecording'])
      )
      .subscribe(() => {
        this.posthogService.startSessionRecording();
        this.recordingStarted = true;
      });

    this.globalService.activeMiniCart$
      .pipe(filter((open) => open && !this.recordingStarted))
      .subscribe(() => {
        this.posthogService.startSessionRecording();
        this.recordingStarted = true;
      });
  }
}
